import { Link } from 'react-router-dom';
import { cx } from '@platform/core/lib/cx';
import { routes } from '@platform/core/lib/routes';
import type { IMenuEntryLinkProps } from './IMenuEntryLinkProps';
import { useEntryCount } from './useEntryCount';

/**
 * Пункт меню типу запису: список типу з поданням і ключем пункту (`?item=` — власний пресет/фільтр і власний збережений стан списку; пункт
 * бібліотеки — ще й режим `?mode=`), підпис в один рядок із трикрапкою (повний — у підказці), живий лічильник праворуч; прострочені — кольором
 * попередження, коли є записи.
 */
export function MenuEntryLink({ ws, moduleKey, rtKey, entry, active, uncounted, plain, dense }: IMenuEntryLinkProps) {
  const count = useEntryCount(ws, rtKey, entry, !uncounted);
  const to = routes.list(moduleKey, rtKey, entry.view ?? undefined, entry.key, entry.mode === 'home' ? undefined : entry.mode);
  return (
    <Link className={cx('mnav__item', plain && 'mnav__item--plain', dense && 'mnav__item--dense', active && 'is-active')} to={to} aria-current={active ? 'page' : undefined}>
      <span className="mnav__label" title={entry.label}>{entry.label}</span>
      {count !== undefined && <span className={cx('mnav__count', entry.warning && count > 0 && 'is-warning')}>{count}</span>}
    </Link>
  );
}
